import type { Expirable } from './models/expirable.model';
import type { Livestream } from './models/livestream.model';

export class LivestreamService {
  readonly LIVESTREAM_ID_KEY = 'singlemusic_livestream_id';

  getLivestreamId(): string | undefined {
    const livestreamData = localStorage.getItem(this.LIVESTREAM_ID_KEY);
    if (!livestreamData) {
      return undefined;
    }
    const livestream = JSON.parse(livestreamData) as Expirable<Livestream>;
    if (!livestream) {
      return undefined;
    }
    const now = new Date();
    if (!!livestream.expiresOn && now.getTime() > livestream.expiresOn) {
      localStorage.removeItem(this.LIVESTREAM_ID_KEY);
      return undefined;
    }
    return livestream.value ? livestream.value.livestreamId : undefined;
  }
}
